import { useState, useMemo, useCallback } from 'react'
import map from 'lodash/map'
import { useLocalStorage } from '../../contexts/LocalStorageContext'

function useNodeSelection(storageKey, nodes) {
  const { getValue, setValue } = useLocalStorage()

  const [selectedNodeId, setSelectedNodeId] = useState(() => {
    return getValue(storageKey)
  })

  const activeNodeId = useMemo(() => {
    if (!nodes || nodes.length === 0) return null
    const nodeIds = map(nodes, 'id')
    if (selectedNodeId && nodeIds.includes(selectedNodeId)) return selectedNodeId
    return nodes[0].id
  }, [nodes, selectedNodeId])

  const handleSelectNode = useCallback((nodeId) => {
    setSelectedNodeId(nodeId)
    setValue(storageKey, nodeId)
  }, [storageKey, setValue])

  return { activeNodeId, handleSelectNode }
}

export default useNodeSelection
